export default "__VITE_ASSET__ZO2Y3P1T__"